import React, { FC } from 'react';
import { FormSection } from 'components/form/FormSection';
import { Input } from 'components/form/Input';
import { ButtonContainer as Buttons } from '@jbc-year-end-adj/2024/features/questions/components/ButtonContainer/ButtonContainer';
import Button from 'jbc-front/components/Button';
import { SubmitHandler, useForm, FormProvider } from 'react-hook-form';
import { generateDefaultValues, Schema, schema } from './schema';
import { HouseHolder } from './query';
import { useEmployeeMutation } from '@jbc-year-end-adj/2024/hooks/graphql/useMutation';
import useReactRouter from 'use-react-router';
import { CreatableSelectField } from '@jbc-year-end-adj/2024/components/react-hook-form/CreatableSelectField';
import { ANSWER_HOUSE_HOLDER } from './mutation';
import { yupResolver } from '@hookform/resolvers/yup';

const RELATIONSHIPS = [
  '本人',
  '夫',
  '妻',
  '実父',
  '実母',
  '義父',
  '義母',
  '長男',
  '長女',
  '兄',
  '姉',
  '弟',
  '妹',
  '祖父',
  '祖母',
  '叔父',
  '叔母'
];

type FormProps = {
  householder?: HouseHolder;
};

export const Form: FC<FormProps> = ({ householder }) => {
  const [answer] = useEmployeeMutation(ANSWER_HOUSE_HOLDER);
  const { history } = useReactRouter();

  const methods = useForm<Schema>({
    defaultValues: generateDefaultValues(householder),
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    watch,
    register,
    formState: { errors }
  } = methods;
  const relationship = watch('householder.relationship');

  const relationshipOptions = RELATIONSHIPS.map(val => ({ value: val, label: val }));
  if (householder?.relationship && !RELATIONSHIPS.includes(householder.relationship)) {
    relationshipOptions.push({ label: householder.relationship, value: householder.relationship });
  }

  const onSubmit: SubmitHandler<Schema> = async data => {
    await answer({
      variables: {
        input: data.householder
      }
    });
    history.push('/employee_input');
  };

  return (
    <FormProvider {...methods}>
      <FormSection>
        <CreatableSelectField
          label="世帯主の続柄"
          options={relationshipOptions}
          hint="リストにない続柄は直接入力して追加できます"
          note="一人暮らしの場合の世帯主は「本人」です。"
          name="householder.relationship"
          required
        />

        {relationship !== '本人' && (
          <Input
            label="氏名"
            isError={!!errors?.householder?.name?.message}
            error={errors?.householder?.name?.message}
            {...register('householder.name')}
            required
          />
        )}
      </FormSection>

      <Buttons>
        <Button primary onClick={handleSubmit(onSubmit)}>
          次へ
        </Button>
      </Buttons>
    </FormProvider>
  );
};
